import { useNavigate } from "react-router-dom";
import "./about-company.scss";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import { companyRegistrationSelector, registerCompanyInfo } from "../../../redux/reducers/company-registration/companyRegistrationSlice";
import { SignupContext } from "../../providers/signupProvider";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { post } from "../../../common/services/api-service";
import { ICompanyInsightInfo, companyInsightSelector, updateCompanyInsight } from "../../../redux/reducers/company-insight/companyInsightSlice";

const AboutCompany: React.FC = () => {

  let apiUrl = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  if (!apiUrl.endsWith('/')) {
    apiUrl += '/';
  }

  const geminiInsightAPIURL = "http://localhost:6001/generateInsightFromCompanyInfo";

  const selectCompnayInfo = useAppSelector(companyRegistrationSelector);
  const dispatch = useAppDispatch();
  const selectCompanyInsight = useAppSelector(companyInsightSelector);
  //const [aboutCompany, setAboutCompany] = useState<string>("");
  const { setCurrentStep } = useContext(SignupContext);
  const [usageOfTecInBusiness, setUsageOfTecInBusiness] = useState<string | undefined>("");
  const [companyInsight, setCompanyInsight] = useState<ICompanyInsightInfo | undefined>(undefined);

  useEffect(() => {
    console.log(
      "Company registration information after filling company name and website url",
      selectCompnayInfo
    );
   setUsageOfTecInBusiness(selectCompnayInfo.usageOfTecInBusiness);
   // setAboutCompany(selectCompnayInfo.aboutTheCompany);
  }, [selectCompnayInfo]);

  useEffect(()=>{

    setCompanyInsight(selectCompanyInsight);

  }, [selectCompanyInsight])

  const navigate = useNavigate();

  const GoToNextStage = async (stage: string) => {

    if (usageOfTecInBusiness) {
      dispatch(
        registerCompanyInfo({
          ...selectCompnayInfo,
          usageOfTecInBusiness: usageOfTecInBusiness,
        })
      );
      setCurrentStep(stage);

      // Make call to AI to generate the insight
      let question: string = "";
      let context: string = `Year of operation of the company is ${
        selectCompnayInfo.YearsInOperation
      }, Business size of the company is ${
        selectCompnayInfo.businessSize
      }, Business type is ${
        selectCompnayInfo.businessType
      }, Main service of the company is ${
        selectCompnayInfo.mainServices
      }, Main customers are ${
        selectCompnayInfo.mainCustomer
      }, company is generating revenu from ${
        selectCompnayInfo.revenueGenService
      },  details of the customer type are ${
        selectCompnayInfo.customerTypeDetails
      }, Main challenges they are facing related to ${
        selectCompnayInfo.challenges
      }. ${selectCompnayInfo.businessChallengeDescription}, ${
        usageOfTecInBusiness
          ? "Technology used in the business are " + usageOfTecInBusiness
          : "They are not using any modern technologies in their business "
      }, Vision of the business is ${selectCompnayInfo.vision}`;

      // todo: Add web scrapping details to the context

      // let recommendations = await AskQuestionWithContextToGemini(context, question);

      // // dispatch the result to react store
      // dispatch(updateCompanyInsight({
      //   ...selectCompanyInsight,
      //   recommendations : recommendations
      // }));

      // console.log("Recommendation from AI ", recommendations);

      // tood: Make a request to api to save the details

      try {
        let updateAPIURL = `${apiUrl}data/company-profile`;
          //"https://trowelwa01.azurewebsites.net/data/company-profile"; //"https://trowelwa01.azurewebsites.net/metadata/company-profile";//"https://trowelwa01.azurewebsites.net/company-profile/upsert";
        let response = await post(updateAPIURL, {
          ...selectCompnayInfo,
        });

        console.log("Response ", response);

        if (response && response["firmId"]) {
          console.log(
            "Successfully created the deatils in db",
            response["firmId"]
          );
          toast.info("Successfully register company details");
        }
      } catch (ex) {
        console.log(ex);
      }
      navigate("/dashboard");
    } else {
      toast("Please fill the details about your company to proceed");
    }
  };

  const AskQuestionWithContextToGemini = async (
    context: string,
    question: string
  ) => {
    // setIsMLProcessing(true);
    // setMlProcessingStatusMessage("Insight generation process initiated");
    let response = await post(geminiInsightAPIURL, {
      context: context,
      question: question,
    });
    console.log("Web scrap response " + response);
    // setIsMLProcessing(false);
    // setMlProcessingStatusMessage("Insight generation completed");
    return response;
  };
  
  const FORM_FIELDS = {
    USAGE_OF_TECH_IN_BUSINESS: "UsageOfTechInBusiness",

  };

  const onTextValueChanged = (
    value: string | undefined,
    optionType: string
  ) => {
    switch (optionType) {
        case FORM_FIELDS.USAGE_OF_TECH_IN_BUSINESS:
        setUsageOfTecInBusiness(value);
        break;
    }
  };

  return (
    <div className="company-other-info-wrapper">
      <div className="company-info-title">Technology in business</div>
      <div>Tell us about the use of technology in your business</div>

      {/* <div className="company-info-form">
        <span>Explain about your company</span>
        <textarea
          placeholder="Company details"
          className="multiline-input"
          value={aboutCompany}
          onChange={(e) => setAboutCompany(e.target.value)}
        />
      </div> */}

    {/* Technology usage in business */}
    <div className="company-info-box">
        <div className="question-text">
        How do you leverage technology to support and grow your business?
        </div>
        <div className="question-options">
          {
            <Form.Control
              as="textarea"
              value={usageOfTecInBusiness}
              onChange={(event) => {
                onTextValueChanged(
                  event?.target.value,
                  FORM_FIELDS.USAGE_OF_TECH_IN_BUSINESS
                );
              }}
            />
          }
        </div>
      </div>

      <div className="wizard-footer">
        <div>Step 4/4</div>
        <div className="wizard-footer__buttons">
          <div
            className="wizard-button"
            onClick={() => {
              navigate("/signup-s3");
            }}
          >
            Back
          </div>
          <div
            className="wizard-button primary-button"
            onClick={() => {
              GoToNextStage("COMPANY");
            }}
          >
            Submit
          </div>
          {/* COMPANY_MORE */}
        </div>
      </div>
    </div>
  );
};

export default AboutCompany;
